export const SEARCH_BAR_SCROLL_TARGET = 'SEARCH_BAR_SCROLL_TARGET';
export const OFFER_LIST_SCROLL_TARGET = 'OFFER_LIST_SCROLL_TARGET';
